const types = {
    SCROLL_TO: "SCROLL_TO",
    SET_ACTIVE_FRAME: "SET_ACTIVE_FRAME",
    SET_FRAME_POSITIONS: "SET_FRAME_POSITIONS"
}

export default types;
